// src/api/branding/brandingApi.ts
/**
 * @file The clinic's public branding read (S6, ClickUp 86d3w1g8u).
 * @module api/branding/brandingApi
 *
 * *** THIS READ NEEDS NO SESSION, AND THAT IS THE POINT. ***
 *
 * `/login` and `/patient/booking-form` are pre-auth surfaces with no session at all, so
 * branding cannot come from the session or the `subscriptions` cookie (decision D1). This
 * module therefore does not import `js-cookie` and the route stays `public` at the gateway — a
 * request that needed a session could not brand the login page, which is the whole feature.
 *
 * Per-clinic resolution comes from `VITE_HEALTHCARE_SERVER`, which serves this moved route
 * (contract §15 row 150) and is already per-clinic in each frontend-runtime-config ConfigMap.
 *
 * ⚠️ The response is NOT trusted here — `BrandingContext` runs it through
 * `normalizeBranding()`. Do not add shape assumptions to this module.
 */

import { ENV } from '../../config/runtimeEnv';
import { Branding } from '../../types/branding/BrandingTypes';
import { http } from '../../lib/http/client';

/** Unauthenticated, throttled 60/min, cached 300 s server-side. */
export const PUBLIC_BRANDING_PATH = '/public/branding';

/**
 * Fetch the clinic's branding.
 *
 * Rejects on transport or HTTP error like any other axios call — the fail-soft
 * behaviour (fall back to `DEFAULT_BRANDING`, never a toast) lives in
 * `BrandingContext`, so a caller that genuinely wants to know it failed still can.
 */
export const fetchPublicBranding = async (): Promise<Branding> => {
	const response = await http.get(`${ENV.VITE_HEALTHCARE_SERVER}${PUBLIC_BRANDING_PATH}`);
	return response.data;
};
